/**
 * Whether the signed-in account holds a password it can sign in with. The
 * profile says so directly (an Owner linked to a provider may keep one); an
 * older response only says the account is LOCAL. Its own module, not the auth
 * context, so a test that mocks the context still gets the real rule.
 */
export const userHasPassword = (
  user: { hasPassword?: boolean; authType?: 'LOCAL' | 'SSO' } | null | undefined,
): boolean => user?.hasPassword ?? user?.authType === 'LOCAL';
